import * as React from "react";
import { cn } from "@/lib/utils";

/** Canon `.hint`: 12px, dim, no italics. The ONE quiet line for hints, captions and empty lists. */
export const HINT_CLASS = "text-meta text-dim";

export function Hint({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn(HINT_CLASS, className)} {...props} />;
}

/** Empty list/panel: the same Hint, left-aligned, optionally followed by the one action that fills it (an AddLink). */
export function EmptyState({ children, action, className, ...props }: React.HTMLAttributes<HTMLDivElement> & { action?: React.ReactNode }) {
  return (
    <div className={cn("flex flex-col items-start gap-1.5 px-1.5 py-1", className)} {...props}>
      <p className={HINT_CLASS}>{children}</p>
      {action}
    </div>
  );
}
